import { render, staticRenderFns } from "./IntegralExchange.vue?vue&type=template&id=5e55cb5f&scoped=true"
import script from "./IntegralExchange.vue?vue&type=script&lang=js"
export * from "./IntegralExchange.vue?vue&type=script&lang=js"
import style0 from "./IntegralExchange.vue?vue&type=style&index=0&id=5e55cb5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e55cb5f",
  null
  
)

export default component.exports